var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white flex", attrs: { "data-grm-comp": "RoomCBT" } },
    [
      _vm.hasEmceeRole()
        ? [
            _c(
              "div",
              { staticClass: "min-w-0 flex-1 flex justify-center" },
              [
                _c("RoomDocView", {
                  staticClass: "flex-1 h-full",
                  attrs: { roomGroupId: "default" },
                }),
                _c("RoomDocPaging", { staticClass: "absolute top-2" }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "min-w-0 flex-1" },
              [_c("RoomCBTView")],
              1
            ),
            _c("div", [_c("RoomCBTViewInfo")], 1),
          ]
        : [
            _c(
              "div",
              { staticClass: "flex-1 flex justify-center bg-gray-50" },
              [
                _c("RoomDocView", {
                  staticClass: "flex-1 h-full",
                  attrs: { roomGroupId: "default" },
                }),
                _c("RoomDocPaging", { staticClass: "absolute top-2" }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-40 border-l p-2 overflow-y-auto relative" },
              [
                _c("RoomCBTTimer", { staticClass: "w-full" }),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  _vm._l(
                    _vm.getUserQuestionList(),
                    function (roomCBTQuestion, i) {
                      return _c(
                        "div",
                        {
                          key: roomCBTQuestion.questionId,
                          staticClass: "flex items-center gap-1",
                          class:
                            i !== 0 &&
                            (i + 1) % roomCBTQuestion.answerList.length === 0 &&
                            i + 1 !== _vm.roomCBT.questionCnt
                              ? "border-b pb-3 mb-3"
                              : "",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "w-8 text-sm inline-block" },
                            [_vm._v(_vm._s(_vm.number(i + 1)) + ".")]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-0.5" },
                            _vm._l(
                              roomCBTQuestion.answerList,
                              function (answer, j) {
                                return _c(
                                  "button",
                                  {
                                    key: answer.answerOrder,
                                    staticClass:
                                      "w-4 h-4 rounded-full text-xs flex justify-center items-center",
                                    class: answer.correct
                                      ? "bg-black"
                                      : "border",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeAnswer(
                                          answer.correct,
                                          answer.answerId,
                                          answer.answerOrder,
                                          roomCBTQuestion
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(j + 1))]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "GrmBtn",
                      { staticClass: "w-full", on: { click: _vm.onComplete } },
                      [_vm._v("제출하기")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }